import { scrollToSection } from "../lib/scroll";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="bg-abyss px-6 pb-12 pt-20"
        >
            <div className="mx-auto flex max-w-6xl flex-col items-center text-center">
                <a
                    href="#top"
                    data-testid="footer-back-to-top"
                    onClick={(e) => {
                        e.preventDefault();
                        scrollToSection("#top");
                    }}
                    className="block"
                    aria-label="Back to top"
                >
                    <img
                        src="/favicon-512.png"
                        alt="Mountain View Pictures mark"
                        className="h-12 w-12 rounded-[6px] object-contain ring-1 ring-white/10"
                    />
                </a>
                <p
                    data-testid="footer-address"
                    className="mt-6 max-w-md text-[11px] leading-relaxed tracking-wide text-cream/40"
                >
                    <span className="font-label text-[9px] uppercase tracking-[0.4em] text-cream/30">
                        Registered Office
                    </span>
                    <br />
                    8C Block 2, Ramaniyam Abbotsbury, No. 42 C.P. Ramaswamy
                    Road, Alwarpet, Chennai – 600018, Tamil Nadu, India
                </p>
                <p
                    data-testid="footer-copyright"
                    className="mt-8 text-xs tracking-wide text-cream/50"
                >
                    © 2026 Mountain View Pictures (OPC) Private Limited
                </p>
                <p
                    data-testid="footer-cin"
                    className="mt-2 text-[11px] tracking-[0.2em] text-cream/35"
                >
                    CIN U59111TN2026OPC198216
                </p>
            </div>
        </footer>
    );
}
